import * as React from 'react'
import { useParams } from 'src/routes/hooks/use-params'
import { getChatInfoByChatUuidApi } from 'src/api/chat-api'
import { dispatch } from 'src/redux/store'
import { setCom100ScriptRef } from 'src/redux/slices/app-slice'

function StandaloneChat() {
  const { uuid } = useParams()
  const [chatInfo, setChatInfo] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  const MAX_ANCHOR_CHECK_ATTEMPTS = 10
  const MAX_COM100_SITE_LOADED_CHECK_ATTEMPTS = 10
  const ANCHOR_CHECK_INTERVAL = 3000
  const COMM100_SITE_LOADED_CHECK_INTERVAL = 3000

  // Get the anchor element for the chat button
  function getAnchor() {
    const container = document.querySelector('div[id^="comm100-float-button"]')
    const anchorDesktop = container?.querySelector('a')

    const anchorMobile =
      document.querySelector('a[aria-label="Chat button, agent online"]') ||
      document.querySelector('a[aria-label="Open Live Chat window"]')

    // document.querySelector('a[aria-label="Chat button, agent offline"]')
    // document.querySelector('a:contains("Leave a message")')

    return anchorDesktop ? anchorDesktop : anchorMobile
  }

  // Check if the anchor is loaded and add the class to the parent element
  function anchorFound(anchor) {
    console.log('Anchor found!')
    anchor.classList.add('chat-link--button')
    anchor.innerHTML = ''
    const parentElement = anchor.parentNode
    parentElement.classList.add('chat-container')

    // Auto-open the chat using Comm100 API
    setTimeout(() => {
      try {
        if (window.Comm100API && typeof window.Comm100API.do === 'function') {
          window.Comm100API.do('livechat.button.click')
          console.log('Chat auto-opened successfully using Comm100API')
          setTimeout(() => {
            const rootContainer = document.getElementById('root')

            if (rootContainer) {
              const isMobile = window.innerWidth < 600
              console.log('Window width:', window.innerWidth)
              console.log('Setting background image for', isMobile ? 'mobile' : 'desktop')

              const backgroundImage = isMobile
                ? "url('/assets/Lead_Engine_Mobile_Screen_Image.png')"
                : "url('/assets/SH-washed_with_Logo_for_Lead_Engine.png')";
              console.log('Background image URL:', backgroundImage)


              rootContainer.style.backgroundImage = backgroundImage
              rootContainer.style.backgroundSize = 'cover'
              rootContainer.style.backgroundPosition = 'center'
              rootContainer.style.backgroundRepeat = 'no-repeat'
            }

            setLoading(false)
          }, 1000)
        } else {
          console.warn('Comm100API.do method not available')
        }
      } catch (error) {
        console.error('Failed to auto-open chat:', error)
      }
    }, 100) // Small delay to ensure API is ready
  }

  // Handle the case when the anchor is not found after maximum attempts
  function anchorNotFound() {
    // Handle the case when the anchor is not found after maximum attempts
    console.log('Anchor not found with maximum attempts!')
  }

  // Check if the site is loaded and then check if the anchor is loaded
  function checkAnchorIsLoaded(appFlowType) {
    console.log('Checking for anchor...')
    const anchor = getAnchor(appFlowType)
    if (!anchor) {
      let attempts = 0
      const interval = setInterval(() => {
        attempts++
        console.log('Checking for anchor...', attempts)
        const newAnchor = getAnchor(appFlowType)
        if (newAnchor) {
          clearInterval(interval)
          anchorFound(newAnchor, appFlowType)
        } else if (attempts >= MAX_ANCHOR_CHECK_ATTEMPTS) {
          clearInterval(interval)
          anchorNotFound()
        }
      }, ANCHOR_CHECK_INTERVAL)
    } else {
      anchorFound(anchor, appFlowType)
    }
  }

  // Check if the site is loaded and then check if the anchor is loaded
  function checkSiteLoaded(t, e, appFlowType) {
    console.log('Checking for site loaded...')
    if (!t.loaded) {
      e('https://standby.comm100vue.com/livechat.ashx?siteId=')
      let attempts = 0
      const interval = setInterval(() => {
        attempts++
        console.log('Checking for site loaded...', attempts)
        checkSiteLoaded(t, e, appFlowType)
        if (attempts >= MAX_COM100_SITE_LOADED_CHECK_ATTEMPTS) {
          clearInterval(interval)
          console.log('Site not loaded after maximum attempts!')
        }
      }, COMM100_SITE_LOADED_CHECK_INTERVAL)
    } else {
      console.log('Site loaded!')
      checkAnchorIsLoaded(appFlowType)
    }
  }

  React.useEffect(() => {
    if (!uuid) {
      setError('UUID parameter is required')
      return
    }

    const fetchChatInfo = async () => {
      try {
        const response = await getChatInfoByChatUuidApi({ chatUuid: uuid })

        if (response?.data) {
          setChatInfo(response.data)
        } else {
          setError('Failed to fetch chat information')
        }
      } catch (err) {
        setError('Failed to fetch chat information')
      } finally {
      }
    }

    fetchChatInfo()
  }, [uuid])

  React.useEffect(() => {
    const interval = setInterval(() => {
      const iframeContainer = document.getElementById('chat_window_container')
      if (iframeContainer) {
        console.log('Chat iframe container found!')
        // iframeContainer.style.minWidth = '100vw'
        clearInterval(interval)
      }
    }, 500)

    return () => clearInterval(interval)
  }, [])

  React.useEffect(() => {
    if (!chatInfo?.agency_uuid || !chatInfo?.chat_js_id) return
    const codePlan = chatInfo.chat_js_id
    const agencyUuid = chatInfo.agency_uuid

    if (!codePlan || !agencyUuid) {
      const script = document.querySelector(
        'script[src*="comm100.com/livechat.ashx?siteId=1000547"]'
      )
      if (script) {
        console.log('Removing script...')
        console.log(script)
        script.remove()
      }

      return
    }
    var cap8UUID = agencyUuid
    window.cap8UUID = cap8UUID
    window.AQPQL = '*** 3RD PARTY LEAD ***'
    window.AQPQLName = chatInfo.name
    window.AQPQLEmail = chatInfo.email
    window.AQPQLPhone = chatInfo.phoneNumber
    window.AQPQLZip = chatInfo.zipPostalCode
    window.AQPQLNotes = chatInfo.notes
    window.AQPQLFirstName = chatInfo.firstName
    window.AQPQLCareNeeds = chatInfo.careNeeds
    window.AQPQLAssessmentType = chatInfo.assessmentType
    window.AQPQLID = uuid

    var Comm100API = window.Comm100API || {}
    window.Comm100API = Comm100API
      ; (function (t) {
        function e(e) {
          var a = document.createElement('script'),
            c = document.getElementsByTagName('script')[0]
          dispatch(setCom100ScriptRef(a)) // Save the script reference
          a.type = 'text/javascript'
          a.async = true
          a.src = e + t.site_id
          c.parentNode.insertBefore(a, c)
          a.onload = () => { }
        }
        t.chat_buttons = t.chat_buttons || []
        t.chat_buttons.push({
          code_plan: codePlan,
          div_id: `comm100-button-${codePlan}`,
        })
        t.site_id = 1000547
        t.main_code_plan = codePlan
        e('https://vue.comm100.com/livechat.ashx?siteId=')

        setTimeout(function () {
          checkSiteLoaded(t, e)
        }, COMM100_SITE_LOADED_CHECK_INTERVAL)
      })(Comm100API, cap8UUID)
  }, [chatInfo])

  return (
    <>
      <div id={`comm100-button-${chatInfo?.chat_js_id}`}></div>

      {loading && (
        <>
          <div className="overlay-container">
            {/* Background */}
            <div className="bg-image" />

            {/* Content */}
            <div className="content">
              <div className="dots">
                {[0, 1, 2].map(i => (
                  <span key={i} style={{ animationDelay: `${i * 0.16}s` }} />
                ))}
              </div>
              <div className="text">Connecting to chat...</div>
            </div>
          </div>

          <style jsx>{`
            .overlay-container {
              position: fixed;
              inset: 0;
              z-index: 9999999999;
              overflow: hidden;
            }

            /* Background image only */
            .bg-image {
              position: absolute;
              inset: 0;
            }

            /* Mobile background */
            @media (max-width: 599px) {
              .bg-image {
                background: url('/assets/Lead_Engine_Mobile_Screen_Image.png') center /
                  cover no-repeat;
              }
            }

            /* Desktop background */
            @media (min-width: 600px) {
              .bg-image {
                background: url('/assets/SH-washed_with_Logo_for_Lead_Engine.png')
                  center / cover no-repeat;
              }
            }


            .content {
              position: relative;
              z-index: 1;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-family: Arial, sans-serif;
            }

            .dots {
              display: flex;
              gap: 8px;
              margin-bottom: 20px;
            }

            .dots span {
              width: 12px;
              height: 12px;
              background: black;
              border-radius: 50%;
              animation: pulse 1.4s ease-in-out infinite;
            }

            @keyframes pulse {
              0%,
              80%,
              100% {
                transform: scale(0);
                opacity: 0.5;
              }
              40% {
                transform: scale(1);
                opacity: 1;
              }
            }

            .text {
              font-size: 18px;
              font-weight: 300;
              color: black;
            }
            /* Mobile-only: nudge the overlay content lower on small screens */
            @media (max-width: 599px) {
              .content {
                padding-top: 18vh;
              }
            }
          `}</style>
        </>
      )}
    </>
  )
}

export default StandaloneChat
